import callCmAPI from 'services/helpers/call-cm-api'
import { RecordEscalationReasonPayload } from 'types'

export type RecordReasonParams = {
  country: string
  payload: RecordEscalationReasonPayload
}

export const recordEscalationReason = ({
  country,
  payload,
}: RecordReasonParams) =>
  callCmAPI('/escalation/update-escalation', {
    method: 'post',
    data: {
      country: country.toUpperCase(),
      localId: payload.local_id,
      reason: payload.reason,
      reason_recorded_by: payload.reason_recorded_by,
    },
  }).then((res) => res.data)
